import './bluefiretotal3/style';
import FormStructure from './bluefiretotal3/form_structure';

export default FormStructure;